import { FilterDetail } from './FilterDetail';
import { FilterCalendar } from './FilterCalendar';
import { FilterRange } from './FilterRange';
import { FilterBoolean } from './FilterBoolean';
import { FilterExistence } from './FilterExistence';
import { FilterSelect } from './FilterSelect';
import { FilterText } from './FilterText';

const FilterComponents = {
    Context: FilterDetail,
    Items: FilterDetail,
    Date: FilterCalendar,
    Range: FilterRange,
    Boolean: FilterBoolean,
    Existence: FilterExistence,
    Select: FilterSelect,
    Text: FilterText,
};
export default FilterComponents;
